const second = 1000;
const minute = 60 * second;

export enum Time {
	'2 seconds' = 2 * second,
	'3 seconds' = 3 * second,
	'10 seconds' = 10 * second,
	'30 seconds' = 30 * second,
	'1 minute' = minute,
	'5 minutes' = 5 * minute,
	'19 minutes' = 19 * minute,
	'20 minutes' = 20 * minute,
}

export enum TimeZones {
	'Europe/Prague' = 'Europe/Prague',
}
